import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_RED } from "../../config/constants";

const Connector1CRed = ({ state, workState }) => (
	<g id="Track-1C-red-connector" transform="translate(800.000000, 728.000000)">
		<g id="line" transform="translate(0.000033, -0.000013)">
			<path
				d="M341.318,320.7813 L310.616,321.0803 C304.534389,321.14005 295.838501,321.901379 289.954837,323.340913"
				strokeLinecap="round"
        strokeWidth={tracksWidth}
				stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}/>
		</g>
	</g>
);

export default Connector1CRed;
